<template>
  <!-- The quiet metadata strip under a node title: owner · mentions · links · last discussed · due.
       Each bit shows only when present; the caller toggles owner/mentions/links/due per surface. -->
  <div class="flex items-center gap-x-2 gap-y-0.5 flex-wrap text-gray-400" :class="sizeClass">
    <span v-if="showOwner && ownerLabel(node)" class="truncate max-w-[11rem]">
      <font-awesome-icon :icon="['fas', 'user']" class="mr-1 text-gray-300" />{{ ownerLabel(node) }}
    </span>
    <span v-if="showMentions && mentionsCount(node)">{{ mentionsCount(node) }} mentions</span>
    <span v-if="linkCount">{{ linkCount }} links</span>
    <span v-if="lastDiscussed(node)">{{ lastLabel }} {{ formatDate(lastDiscussed(node)) }}</span>
    <span v-if="showDue && node.due_date" :class="overdue(node) ? 'text-red-500 font-medium' : ''">due {{ formatDate(node.due_date) }}</span>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { fmt } from "@/components/EngagementTracker/engagementTrackerHelpers.js";

library.add(faUser);

export default {
  name: "ET_MetaRow",
  components: { FontAwesomeIcon },
  props: {
    node: { type: Object, required: true },
    // Owner is suppressed when a next-step callout (which carries its own owner chip) is shown.
    showOwner: { type: Boolean, default: true },
    showMentions: { type: Boolean, default: true },
    showDue: { type: Boolean, default: true },
    // Relationship count; the caller resolves edges (>0 to show "N links").
    linkCount: { type: Number, default: 0 },
    // "last" (cards/compact) or "last discussed" (full detail).
    lastLabel: { type: String, default: "last" },
    size: { type: String, default: "sm" },
  },
  computed: {
    sizeClass() {
      return this.size === "md" ? "text-xs" : "text-[11px]";
    },
  },
  methods: {
    ownerLabel: fmt.ownerLabel,
    mentionsCount: fmt.mentionsCount,
    lastDiscussed: fmt.lastDiscussed,
    formatDate: fmt.formatDate,
    overdue: fmt.overdue,
  },
};
</script>
